<template>
    <div class="modal-static" :class="{active:active}">
        <div @click="close" class="modal-static__bg"></div>
        <div class="modal-static__pos">
            <div class="modal-static__content">
                <div class="modal-static__wrap">
                    <button-close @click="close"/>
                    <div class="modal-static__inner">
                        <slot/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {computed, watch} from "vue";

export default {
    name: "modal-static",
    props: {
        active: {
            type: Boolean,
            default: false
        }
    },
    setup(props, {emit}) {
        const active = computed(() => {
            if (props.active) {
                document.body.classList.add('overflow-hidden');
            } else {
                document.body.classList.remove('overflow-hidden');
            }
            return props.active;
        })

        const open = () => {
            emit("open");
        }

        const close = () => {
            emit("close");
        }

        return {
            active,
            open,
            close
        }
    }
}
</script>

<style lang="scss">

@use "@/scss/design-library/functions/calculate";
@use "@/scss/design-library/grid";
@use "@/scss/design-library/colors";
@use "@/scss/design-library/typography";

@use "@material/layout-grid";
@use "sass:map";

.modal-static {

    box-sizing: border-box;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1200;

    opacity: 0;
    pointer-events: none;

    transition: opacity linear .25s;

    &.active {
        opacity: 1;
        pointer-events: all;
    }

    &__bg {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: #{colors.$doehler-blue};
        opacity: .7;
        z-index: 10;
    }

    &__pos {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }

    &__content {
        @each $size, $margin in layout-grid.$default-margin {
            @include layout-grid.media-query_($size) {
                width: calc(100% - #{2 * $margin});
            }
        }

        padding: #{calculate.rem(32)};

        @include grid.media-query_up_(tablet_portrait) {
            padding: #{calculate.rem(48)};
        }

        box-sizing: border-box;
        max-width: #{calculate.rem(908)};
        box-shadow: 0px #{calculate.rem(20)} #{calculate.rem(75)} rgba(0, 0, 0, 0.1);
        border-radius: #{calculate.rem(12)};
        background-color: #{colors.$white};
        position: relative;
        z-index: 20;

        max-height: 95vh;
        overflow-y: auto;
        overflow-x: hidden;
    }

    &__wrap {
        position: relative;
    }

    &__inner {
        > * {
            &:first-child {
                margin-top: 0;
            }
            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    &__overline,
    &__headline,
    &__subline {
        width: calc(100% - #{calculate.rem(40)});
    }

    &__headline {
        @include typography.headline2();
        color: #{colors.$black};
        margin-bottom: #{calculate.rem(6)};
    }

    &__subline {
        @include typography.subheader2();
        color: #{colors.$doehler-blue};
        margin-bottom: #{calculate.rem(12)};
    }

    h1.modal-static__subline {
        @include typography.subheader1();
    }

    h2.modal-static__subline {
        @include typography.subheader2();
    }

    &__intro {
        @include typography.body1();
        color: #{colors.$anthrazit};
        margin-bottom: #{calculate.rem(16)};
    }

    &__youtube {
        width: 100%;
        aspect-ratio: 16 / 9;
        margin-top: #{calculate.rem(16)};
        margin-bottom: #{calculate.rem(16)};
        iframe {
            width: 100%;
            height: 100%;
        }
    }

    &__image {
        border-radius: #{calculate.rem(16)};
        overflow: hidden;
        margin-bottom: #{calculate.rem(16)};
        img {
            transition: all ease-out .5s;
        }
    }

    &__description {
        @include typography.body1();
        color: #{colors.$anthrazit};
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.95) 57.5%, #FFFFFF 73%);
        overflow: hidden;
        max-height: #{calculate.rem(130)};
        margin-bottom: #{calculate.rem(16)};
    }

    &__claim {
        @include typography.headline3();
        color: #{colors.$black};
        margin-bottom: #{calculate.rem(12)};
    }

    &__actions {
        margin-top: #{calculate.rem(45)};
        text-align: right;
    }

    .button-close {
        position: absolute;
        top: #{calculate.rem(-8)};
        right: #{calculate.rem(-8)};
    }

}
</style>
